import Styles from "./styles.module.scss";
import loginImage from "../../assets/images/login-bg-man.webp"

function AuthMedia() {

    return (
        <div className={Styles.loginImage}>
            <span className={Styles.graphicIconBig}></span>
            <div className={Styles.loginImageWrap}>
                <img src={loginImage} className={Styles.image} alt=" "/>
            </div>
        </div>
        );
    }
    
export default AuthMedia;